module.exports = __webpack_public_path__ + "img/more.37d151c1.png";